'use strict'

$ ->
  $mpp = $ '.mpp-container'

  $mpp.find('.small-map').click ->
    $target = $mpp.find('.offers-map')
    $target = $mpp.find('.nearby-deals') unless $target.length > 0
    return unless $target.length > 0
    $('body').scrollTo $target, 400
